import {EventEmitter, Injectable, OnInit, Output} from '@angular/core';
import {HttpService} from '../http-service.service';
import {Observable} from 'rxjs';
import {ApiConst, KindOfRequest} from '../api-const';

/**
 * Service that handle workflow request, like getting list of workflows, list of fold of a certain space...
 */
@Injectable()
export class VirtualPrinterService implements OnInit {

  @Output()
  public setVirtualPrinterList: EventEmitter<boolean>;
  @Output()
  public setVirtualPrinterPackageList: EventEmitter<boolean>;
  /**
   * Default constructor, do nothing
   *
   * @param {HttpService} httpService - handle http Request
   */
  constructor(private httpService: HttpService) {  }

  public ngOnInit() {

  }

  /**
   * get the lists of existing packageList ( specific and generics )
   */
  public updateDownloadableList(): void {
    this.getPrinterPackageList();
    this.getPrinterInstallerList();
  }

  /**
   * get the list of existing packageList
   * @return {Observable<any[]>}
   */
  public getPrinterPackageList(): Observable<any> {
    return this.httpService.$post(ApiConst.getCustomerInstallerPackagesList, '');
  }

  /**
   * get the list of existing generic virtual printer installer
   * @return {Observable<any[]>}
   */
  public getPrinterInstallerList(): Observable<any> {
    return this.httpService.$post(ApiConst.getPrinterInstallerList, '');
  }

  /**
   * download generic virtual printer
   *
   */
  public downloadVirtualPrinter( postData ): Observable<any> {
    return this.httpService.$post(ApiConst.downloadPrinterInstaller, postData);
  }

  public uploadVirtualPrinter( url: KindOfRequest, postData: any, altData: any ): Observable<any> {
    return this.httpService.$post( url, postData );
  }

  public deleteVirtualPrinter( url: KindOfRequest, postData: any ): Observable<any> {
    return this.httpService.$post(url, postData);
  }
}
